import Point3D from '../geom/Point3D'
import CircleDT from './CircleDT'
import BoundingBoxDT from './BoundingBoxDT'

function TriangleDT(A, B, C) {
    this.a = null;
    this.b = null;
    this.c = null;

    this.abnext = null;
    this.bcnext = null;
    this.canext = null;
    this.circum = null;

    this.mc = 0;
    this.halfplane = false;
    this.mark = false;

    if (C != null) {
        this.a = A;
        var res = C.pointLineTest(A, B);
        if ((res <= Point3D.LEFT) ||
            (res == Point3D.INFRONTOFA) ||
            (res == Point3D.BEHINDB)) {
            this.b = B;
            this.c = C;
        } else { // RIGHT
            console.info("Warning, ajTriangle(A,B,C) " + "expects points in counterclockwise order.");
            console.info("" + A + B + C);
            this.b = C;
            this.c = B;
        }
        this.circumcircle();
    } else {
        this.a = A;
        this.b = B;
        this.halfplane = true;
    }
}

TriangleDT.prototype = {


    isHalfplane: function() {
        return this.halfplane;
    },

    setIsHalfplane: function(value) {
        this.halfplane = value
    },

    /**
     * returns the first vertex of this triangle.
     */
    p1: function() {
        return this.a;
    },

    /**
     * returns the second vertex of this triangle.
     */
    p2: function() {
        return this.b;
    },

    /**
     * returns the 3th vertex of this triangle.
     */
    p3: function() {
        return this.c;
    },

    /**
     * returns the consecutive triangle which shares this triangle p1,p2 edge. 
     */
    next_12: function() {
        return this.abnext;
    },

    /**
     * returns the consecutive triangle which shares this triangle p2,p3 edge. 
     */
    next_23: function() {
        return this.bcnext;
    },

    /**
     * returns the consecutive triangle which shares this triangle p3,p1 edge. 
     */
    next_31: function() {
        return this.canext;
    },






    /**
     * @return  The bounding rectange between the minimum and maximum coordinates
     *                of the triangle
     */
    getBoundingBox: function() {
        var lowerLeft = new Point3D(Math.min(this.a.x, Math.min(this.b.x, this.c.x)), Math.min(this.a.y, Math.min(this.b.y, this.c.y)));
        var upperRight = new Point3D(Math.max(this.a.x, Math.max(this.b.x, this.c.x)), Math.max(this.a.y, Math.max(this.b.y, this.c.y)));
        return BoundingBoxDT.createFromLowerLeftAndUpperRight(lowerLeft, upperRight);
    },

    switchneighbors: function(Old, New) {
        if (this.abnext == Old) this.abnext = New;
        else if (this.bcnext == Old) this.bcnext = New;
        else if (this.canext == Old) this.canext = New;
        else console.info("Error, switchneighbors can't find Old.");
    },

    neighbor: function(p) {
        if (this.a == p) return this.canext;
        if (this.b == p) return this.abnext;
        if (this.c == p) return this.bcnext;
        console.info("Error, neighbors can't find p: " + p);
        return null;
    },

    equals: function(t) {
        return (t == this) || (t.toString() == this.toString());
    },

    /**
     * Returns the neighbors that shares the given corner and is not the previous triangle.
     * @param p The given corner
     * @param prevTriangle The previous triangle.
     * @return The neighbors that shares the given corner and is not the previous triangle.
     * 
     * By: Eyal Roth & Doron Ganel.
     */
    nextNeighbor: function(p, prevTriangle) {
        var neighbor = null;

        if (this.a.equals(p)) {
            neighbor = this.canext;
        }
        if (this.b.equals(p)) {
            neighbor = this.abnext;
        }
        if (this.c.equals(p)) {
            neighbor = this.bcnext;
        }

        // Udi Schneider: Added a condition check for isHalfPlane. If the current
        // neighbor is a half plane, we also want to move to the next neighbor    
        if (neighbor.equals(prevTriangle) || neighbor.isHalfplane()) {
            if (this.a.equals(p)) {
                neighbor = this.abnext;
            }
            if (this.b.equals(p)) {
                neighbor = this.bcnext;
            }
            if (this.c.equals(p)) {
                neighbor = this.canext;
            }
        }

        return neighbor;
    },

    circumcircle: function() {

        var u = ((this.a.x - this.b.x) * (this.a.x + this.b.x) + (this.a.y - this.b.y) * (this.a.y + this.b.y)) / 2.0;
        var v = ((this.b.x - this.c.x) * (this.b.x + this.c.x) + (this.b.y - this.c.y) * (this.b.y + this.c.y)) / 2.0;
        var den = (this.a.x - this.b.x) * (this.b.y - this.c.y) - (this.b.x - this.c.x) * (this.a.y - this.b.y);
        if (den == 0) // oops, degenerate case
            this.circum = new CircleDT(this.a, Number.POSITIVE_INFINITY);
        else {
            var cen = new Point3D((u * (this.b.y - this.c.y) - v * (this.a.y - this.b.y)) / den,
                (v * (this.a.x - this.b.x) - u * (this.b.x - this.c.x)) / den);
            this.circum = new CircleDT(cen, cen.distance2Point(this.a));
        }
        return this.circum;
    },

    circumcircle_contains: function(p) {
        return this.circum.radius > this.circum.center.distance2Point(p);
    },

    toString: function() {
        var res = ""; //+_id+") ";
        res += this.a.toString() + this.b.toString();
        if (!this.halfplane)
            res += this.c.toString();
        // res +=this.c.toString() +"   | "+this.abnext._id+" "+this.bcnext._id+" "+this.canext._id;
        return res;
    },

    /**
     * determinates if this triangle contains the point p.
     * @param p the query point
     * @return true iff p is not null and is inside this triangle (Note: on boundary is considered inside!!).
     */
    contains: function(p) {
        var ans = false;
        if (this.halfplane || p == null) return false;

        if (this.isCorner(p)) {
            return true;
        }

        var a12 = p.pointLineTest(this.a, this.b);
        var a23 = p.pointLineTest(this.b, this.c);
        var a31 = p.pointLineTest(this.c, this.a);

        if ((a12 == Point3D.LEFT && a23 == Point3D.LEFT && a31 == Point3D.LEFT) ||
            (a12 == Point3D.RIGHT && a23 == Point3D.RIGHT && a31 == Point3D.RIGHT) ||
            (a12 == Point3D.ONSEGMENT || a23 == Point3D.ONSEGMENT || a31 == Point3D.ONSEGMENT))
            ans = true;

        return ans;
    },

    /**
     * determinates if this triangle contains the point p.
     * @param p the query point
     *  @return true iff p is not null and is inside this triangle (Note: on boundary is considered outside!!).
     */
    contains_BoundaryIsOutside: function(p) {
        var ans = false;
        if (this.halfplane || p == null)
            return false;

        if (this.isCorner(p)) {
            return true;
        }

        var a12 = p.pointLineTest(this.a, this.b);
        var a23 = p.pointLineTest(this.b, this.c);
        var a31 = p.pointLineTest(this.c, this.a);

        if ((a12 == Point3D.LEFT && a23 == Point3D.LEFT && a31 == Point3D.LEFT) ||
            (a12 == Point3D.RIGHT && a23 == Point3D.RIGHT && a31 == Point3D.RIGHT))
            ans = true;

        return ans;
    },

    /**
     * Checks if the given point is a corner of this triangle.
     * @param p The given point.
     * @return True iff the given point is a corner of this triangle.
     * 
     * By Eyal Roth & Doron Ganel.
     */
    isCorner: function(p) {
        return (p.x == this.a.x && p.y == this.a.y) || (p.x == this.b.x && p.y == this.b.y) || (p.x == this.c.x && p.y == this.c.y);
    },


    //Doron
    fallInsideCircumcircle: function(arrayPoints) {
        var isInside = false;
        var p1 = this.p1();
        var p2 = this.p2();
        var p3 = this.p3();
        var i = 0;
        while (!isInside && i < arrayPoints.length) {
            var p = arrayPoints[i];
            if (!p.equals(p1) && !p.equals(p2) && !p.equals(p3)) {
                isInside = this.circumcircle_contains(p);
            }
            i++;
        }

        return isInside;
    },

    /**
     * compute the Z value for the X,Y values of q. <br />
     * assume this triangle represent a plane --> q does NOT need to be contained
     * in this triangle.
     * 
     * @param q query point (its Z value is ignored).
     * @return the Z value of this plane implies by this triangle 3 points.
     */
    z_value: function(q) {
        if (q == null || this.halfplane) throw "*** ERR wrong parameters, can't approximate the z value ..***: " + q;
        /* incase the query point is on one of the points */
        if (q.x == this.a.x && q.y == this.a.y) return this.a.z;
        if (q.x == this.b.x && q.y == this.b.y) return this.b.z;
        if (q.x == this.c.x && q.y == this.c.y) return this.c.z;

        /* 
         *  plane: aX + bY + c = Z:
         *  2D line: y= mX + k
         *  
         */
        var X = 0;
        var x0 = q.x;
        var x1 = this.a.x;
        var x2 = this.b.x;
        var x3 = this.c.x;
        var Y = 0;
        var y0 = q.y;
        var y1 = this.a.y;
        var y2 = this.b.y;
        var y3 = this.c.y;
        var Z = 0;
        var m01 = 0;
        var k01 = 0;
        var m23 = 0;
        var k23 = 0;

        // 0 - regular, 1-horisintal , 2-vertical.
        var flag01 = 0;
        if (x0 != x1) {
            m01 = (y0 - y1) / (x0 - x1);
            k01 = y0 - m01 * x0;
            if (m01 == 0) flag01 = 1;
        } else { // 2-vertical.
            flag01 = 2; //x01 = x0
        }
        var flag23 = 0;
        if (x2 != x3) {
            m23 = (y2 - y3) / (x2 - x3);
            k23 = y2 - m23 * x2;
            if (m23 == 0) flag23 = 1;
        } else { // 2-vertical.
            flag23 = 2; //x01 = x0
        }

        if (flag01 == 2) {
            X = x0;
            Y = m23 * X + k23;
        } else {
            if (flag23 == 2) {
                X = x2;
                Y = m01 * X + k01;
            } else { // regular case 
                X = (k23 - k01) / (m01 - m23);
                Y = m01 * X + k01;

            }
        }
        var r = 0;
        if (flag23 == 2) { r = (y2 - Y) / (y2 - y3); } else { r = (x2 - X) / (x2 - x3); }
        Z = this.b.z + (this.c.z - this.b.z) * r;
        if (flag01 == 2) { r = (y1 - y0) / (y1 - Y); } else { r = (x1 - x0) / (x1 - X); }
        var qZ = this.a.z + (Z - this.a.z) * r;
        return qZ;
    },

    /**
     * compute the Z value for the X,Y values of q.
     * assume this triangle represent a plane --> q does NOT need to be contained
     * in this triangle.
     *   
     * @param x  x-coordinate of the query point.
     * @param y  y-coordinate of the query point.
     * @return z (height) value approximation given by the triangle it falls in.
     * 
     */
    computeZ: function(x, y) {
        return this.z_value(new Point3D(x, y));
    },

    /**
     * compute the Z value for the X,Y values of q.
     * assume this triangle represent a plane --> q does NOT need to be contained
     * in this triangle.
     *   
     * @param q query point (its Z value is ignored).
     * @return q with updated Z value.
     * 
     */
    computeZPoint: function(q) {
        var z = this.z_value(q);
        return new Point3D(q.x, q.y, z);
    }
};

export default TriangleDT;